import { getConversionFactorValue } from '@shared/helpers/conversion-factors.helpers';
import { SbefGroupCode } from '@shared/construction/sbef.model';
import type { Results } from '@shared/models/unit.model';

/**
 * SBEF groups omitted from the report Elements table. Site operations
 * (group 9 / A5) stays in — it is the climate-relevant site bucket.
 */
export const DEFAULT_REPORT_EXCLUDED_SBEF_GROUP_CODES: readonly SbefGroupCode[] =
  [SbefGroupCode.SanitationAndDemolition, SbefGroupCode.Ground];

/**
 * True when a report SBEF group row carries measurable scoped CO₂e per m² GFA.
 */
export const hasPositiveSbefGroupCo2e = (sumsPerGfa: Results): boolean =>
  getConversionFactorValue(sumsPerGfa, 'co2e') > 0;

/**
 * True when scoped proposal rollup results carry measurable CO₂e per m² GFA
 * (lifecycle column on the report dashboard).
 */
export const hasPositiveCo2ePerGfa = (resultsPerGfa: Results): boolean =>
  getConversionFactorValue(resultsPerGfa, 'co2e') > 0;
